/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Trackermodal_Invalidorigin2Inputs */

const he_extension_trackermodal_invalidorigin2 = /** @type {(inputs: Extension_Trackermodal_Invalidorigin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דף זה חייב להיפתח מתוך התוסף של PriceDrop.`)
};

const en_extension_trackermodal_invalidorigin2 = /** @type {(inputs: Extension_Trackermodal_Invalidorigin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page must be opened from the PriceDrop browser extension.`)
};

/**
* | output |
* | --- |
* | "This page must be opened from the PriceDrop browser extension." |
*
* @param {Extension_Trackermodal_Invalidorigin2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_trackermodal_invalidorigin2 = /** @type {((inputs?: Extension_Trackermodal_Invalidorigin2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Trackermodal_Invalidorigin2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_trackermodal_invalidorigin2(inputs)
	return en_extension_trackermodal_invalidorigin2(inputs)
});
export { extension_trackermodal_invalidorigin2 as "extension_trackerModal_invalidOrigin" }